<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="title-section form-section">
            <h1 class="page-title text-center">Apply Now!</h1>
            <p class="page-desc text-center">Real Estate Professional Errors & Omissions Insurance <br />EXPRESS APPLICATION</p>
            <img
              src="../../../public/assets/images/calc.png"
              class="title-section-img"
              alt="background image"
            >
          </article>
          <article class="d-flex flex-column align-items-center px-4 pb-5 form-section">
            <div class="d-flex" style="max-width: 651px;">
              <i class="legalese-fa fas fa-info-circle"></i>
              <div class="d-flex flex-column">
                <p class="text-center flex">
                  Instructions: To be eligible for this application you must be able to answer "true" to statements 1-7 below.
                  Please contact our office if you are not eligible for this program or need coverage for services not offered under the Express
                  program.
                </p>
              </div>
            </div>
          </article>
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section flex">
              <h2 class="form-title">Personal</h2>
              <img
                src="../../../public/assets/images/glasses.png"
                class="title-section-img form-title-img"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Applicant Firm Name:
                    </label>
                    <input
                      type="text"
                      name="applicantFirmName"
                      v-model="rxApplication.applicantFirmName"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      :disabled="state.applicantFirmNameValid"
                    >
                    <span
                      v-show="errors.has('applicantFirmName')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('applicantFirmName') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Contact:
                    </label>
                    <input
                      type="text"
                      name="contact"
                      v-model="rxApplication.contact"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('contact')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('contact') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Principal Street Address:
                    </label>
                    <input
                      type="text"
                      name="address"
                      v-model="rxApplication.customer.address"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('address')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('address') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                      type="text"
                      name="city"
                      v-model="rxApplication.customer.city"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('city')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('city') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                      class="orep-select w-100"
                      style="height: 40px; width: 383px;"
                      name="state"
                      v-model="rxApplication.customer.state"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                    <span
                      v-show="errors.has('state')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('state') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                        type="text"
                        name="zipCode"
                        v-model="rxApplication.customer.zipCode"
                        class="orep-text-input w-100"
                        v-validate="'required|numeric|length:5'"
                        maxlength="5"
                        inputmode="numeric"
                        @keypress="!/^\d$/.test($event.key) ? ($event.preventDefault(), zipCodeError = 'Please enter numeric values only') : (zipCodeError = '')"
                        @input="validateBeforeSubmit()"
                    >
                    <span v-if="zipCodeError" class="text-danger small">{{ zipCodeError }}</span>
                    <span
                      v-show="errors.has('zipCode')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('zipCode') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      County:
                    </label>
                    <input
                      type="text"
                      name="county"
                      v-model="rxApplication.customer.county"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('county')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('county') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-12">
                    <label for class="orep-label mb-0 ml-1">
                      Mailing Address:
                    </label>
                    <input
                      type="text"
                      name="mailingAddress"
                      v-model="rxApplication.mailingAddress"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('mailingAddress')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('mailingAddress') | filterText }}</span>
                  </div>
                </div>

                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Phone:
                    </label>
                    <input
                      type="text"
                      name="phone"
                      v-model="rxApplication.customer.phone"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('phone')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('phone') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Fax:
                    </label>
                    <input
                      type="text"
                      name="fax"
                      v-model="rxApplication.customer.fax"
                      class="orep-text-input w-100"
                    >
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="mr-1"></span>Email:
                    </label>
                    <input
                      type="email"
                      name="email"
                      autocomplete="email"
                      v-model="rxApplication.customer.email"
                      class="orep-text-input w-100"
                      v-validate="'required|email'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('email')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('email') | filterText }}</span>
                  </div>

                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                Total Number of professionals earning $20,000/yr or more:
              </label>
              <input
                type="text"
                name="numberOfProfessionalsEarningsGreaterThanTwentyThousand"
                v-model="rxApplication.numberOfProfessionalsEarningsGreaterThanTwentyThousand"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('numberOfProfessionalsEarningsGreaterThanTwentyThousand')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('numberOfProfessionalsEarningsGreaterThanTwentyThousand') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                Total Number of professionals earning less than $20,000/yr:
              </label>
              <input
                type="text"
                name="numberOfProfessionalsEarningsLessThanTwentyThousand"
                v-model="rxApplication.numberOfProfessionalsEarningsLessThanTwentyThousand"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('numberOfProfessionalsEarningsLessThanTwentyThousand')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('numberOfProfessionalsEarningsLessThanTwentyThousand') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                Annual Number of Transaction Sides (on closed real estate sales):
              </label>
              <input
                type="text"
                name="annualNumberOfTransaction"
                v-model="rxApplication.annualNumberOfTransaction"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('annualNumberOfTransaction')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('annualNumberOfTransaction') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                Gross Commission Income for past 12 months $:
              </label>
              <input
                type="text"
                name="grossCommissionIcomeFor12Months"
                v-model="rxApplication.grossCommissionIcomeFor12Months"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('grossCommissionIcomeFor12Months')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('grossCommissionIcomeFor12Months') | filterText }}</span>
            </article>
            <article class="input-section form-section">
              <div class="row align-items-center mx-1 pb-0 row">
                <label for class="orep-label mb-0 col-md-12">Status of Insured: </label>
                <div class="radio orep-radio-wrapper col-md-12">
                  <label>
                    <input
                      type="radio"
                      name="independentContractor"
                      value="independentContractor"
                      class="orep-radio"
                      v-validate="'required|included:independentContractor,soleProprietor,partnership,corporation'"
                      @change="validateBeforeSubmit()"
                      v-model="rxApplication.statusOfInsured"
                    >
                    <span class="radio-span">Independent Contractor</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper col-md-12">
                  <label>
                    <input
                      type="radio"
                      name="soleProprietor"
                      value="soleProprietor"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rxApplication.statusOfInsured"
                    >
                    <span class="radio-span">Sole Proprietor</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper col-md-12">
                  <label>
                    <input
                      type="radio"
                      name="partnership"
                      value="partnership"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rxApplication.statusOfInsured"
                    >
                    <span class="radio-span">Partnership/LLP</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper col-md-12">
                  <label>
                    <input
                      type="radio"
                      name="corporation"
                      value="corporation"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rxApplication.statusOfInsured"
                    >
                    <span class="radio-span">Corporation/LLC</span>
                  </label>
                </div>
                <span
                  v-show="errors.has('independentContractor')"
                  class="help is-danger form-errors text-danger mt-0 mb-2"
                >{{ errors.first('independentContractor') | filterText }}</span>
              </div>
            </article>
            <article class="input-section form-section">

              <div class="radio orep-radio-wrapper solo-checkbox">
                <label for class="orep-label">
                  <input
                    type="checkbox"
                    name="newBusinessAccount"
                    class="orep-radio w-40"
                    v-model="rxApplication.newBusinessAccounts"
                  >
                  <span class="radio-span solo-checkbox-span">
                    NEW BUSINESS ACCOUNTS
                  </span>
                </label>
              </div>
              <div class="row">

                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    Desired Effective Date:
                  </label>
                  <datepicker
                    name="effectiveDate"
                    v-model="rxApplication.effectiveDate"
                    v-validate="'required'"
                    format="MM/dd/yyyy"
                    input-class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                    :disabled="state.effectiveDateValid"
                    :clearButton="false"
                    :value="computedDates"
                  ></datepicker>
                  <span
                    v-show="errors.has('effectiveDate')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('effectiveDate') | filterText }}</span>
                </div>
                <div class="col-md-6">
                  <label for class="orep-label mb-0 ml-1">
                    Retroactive Date:
                  </label>
                  <datepicker
                    name="retroactiveDate"
                    v-model="rxApplication.retroactiveDate"
                    format="MM/dd/yyyy"
                    input-class="orep-text-input w-100"
                    :disabled="state.retroactiveDateValid"
                    :clearButton="false"
                    :value="computedDates"
                  ></datepicker>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-6 mt-1 small">
                  <span>We cannot backdate coverage.</span>
                </div>
                <div class="col mt-1 small">
                    <span>
                      If you have current coverage, but don't know your Retroactive Date, please leave blank.
                    </span>
                </div>
              </div>
                <div  v-if="!this.state.signedInUser" class="flex wrap" style="margin-top: 20px">
                  <div class="row">
                    <div class="col-md-8">
                      <label for class="orep-label">
                        Do you have an active E&O policy of your own that is currently in force?                   </label>
                    </div>
                    <div class="col-md-4 d-flex flex-column justify-content-center">
                      <div class="d-flex flex-row">
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="noPriorCoverage"
                              :value="true"
                              class="orep-radio"
                              v-validate="'required'"
                              @change="validateBeforeSubmit()"
                              v-model="rxApplication.noPriorCoverage"
                            >
                            <span class="radio-span">True</span>
                          </label>
                        </div>
                        <div class="radio orep-radio-wrapper">
                          <label>
                            <input
                              type="radio"
                              name="noPriorCoverage"
                              :value="false"
                              class="orep-radio"
                              @change="validateBeforeSubmit()"
                              v-model="rxApplication.noPriorCoverage"
                            >
                            <span class="radio-span">False</span>
                          </label>
                        </div>
                      </div>
                      <span
                        v-show="errors.has('noPriorCoverage')"
                        class="help is-danger form-errors text-danger"
                      >{{ errors.first('noPriorCoverage') | filterText }}</span>
                    </div>
                  </div>
                </div>
            </article>
            <article class="input-section form-section">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label for class="orep-label">
                  <input
                    type="checkbox"
                    name="placeCoverageWithAlternativeInsuranceCompany"
                    class="orep-radio w-40"
                    v-model="rxApplication.renewalAccounts"
                  >
                  <span class="radio-span solo-checkbox-span">RENEWAL ACCOUNTS</span>
                </label>
              </div>
              <label for class="orep-label">
                Expiring Policy Number:
              </label>
              <input
                type="text"
                name="expiringPolicyNumber"
                v-model="rxApplication.expiringPolicyNumber"
                class="orep-text-input"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('expiringPolicyNumber')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('expiringPolicyNumber') | filterText }}</span>
              <label class="orep-label mt-3 ml-3">
                if you do not know your expiring policy number, please leave blank
              </label>
            </article>
            <article class="input-section form-section">
              <div class="radio orep-radio-wrapper solo-checkbox" style="padding-bottom: 25px">
                <label>
                  <input
                    type="checkbox"
                    name="emailPolicy"
                    class="orep-radio w-40"
                    v-model="rxApplication.emailPolicy"
                  >
                  <span class="radio-span solo-checkbox-span">
                    In lieu of mailing my policy, please Email my policy to the above address. I agree to accept an electronic copy of my application with my policy.
                  </span>
                </label>
              </div>
              <label v-if="getApplicantType === 'OREP'"  for class="orep-label">
            <i class="fas fa-exclamation-triangle not-eligible"></i><span>
                  If you have a policy in force, you will need prior acts coverage. Attach a copy of your current Declarations page
showing the prior acts date.
                </span>
              </label>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rx-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToNext('rx-application-7')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid|| !state.pageSixIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
                    :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('rx-application-ca-2')"
            v-if="rxApplication.customer.state === 'CA'">Next</button>

            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('rx-application-2')"
            v-else >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";
var moment = require('moment')

export default {
  name: 'rx-application-1',
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    rxApplication() {
      return this.$store.state.rxApplication.rxApplication;
    },
    state() {
      return this.$store.state.rxApplication;
    },
    errorMsg() {
      return this.$store.state.rxApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/rx-application-amba/' || this.rxApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if ( first === '/portal/rx-application-realshield/' || this.rxApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      if (this.rxApplication.grossCommissionIcomeFor12Months > 166000 ){
        // eslint-disable-next-line no-param-reassign
        routeName = 'rx-application-standard-program',
        this.$router.push({
          name: routeName,
        });
      } else {
        this.loading = true;
        this.rxApplication.customer.contactName = this.state.rxApplication.contact;
        this.rxApplication.customer.companyName = this.state.rxApplication.applicantFirmName;
        this.rxApplication.customer.isRxApplication = 'True';
        this.rxApplication.customer.appStatus = APP_STATUS.Partially_Completed;

        if (this.getApplicantType === 'Mercer'){
          this.rxApplication.customer.partnerName = 'Mercer';
        }
        else if (this.getApplicantType === 'Realshield') {
          this.rxApplication.customer.partnerName = 'Realshield';
        }

        this.$store.dispatch('rxApplication/createCustomer');
      }
    },

    navigateToNextCustomLink() {
      window.open("https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf", "_blank");
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.rxApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .page-desc {
    width: 295px;
    height: 45px;
  }
  .form-title {
    font-size: 35px !important;
  }
  .w-40 {
    flex: 0 0 40px;
  }
</style>
